import { useEffect, useState } from "react";
import { fetchSignupConfig } from "plg/api/plgAuth";
import type { PlgSignupConfig } from "plg/types";

let cached: PlgSignupConfig | null = null;
let inflight: Promise<PlgSignupConfig> | null = null;

/** Drops a failed/stale config so the "Try again" button on the load-error card refetches. */
export function resetSignupConfigCache() {
  cached = null;
  inflight = null;
}

export default function usePlgSignupConfig() {
  const [config, setConfig] = useState<PlgSignupConfig | null>(cached);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (cached) return undefined;
    let cancelled = false;
    inflight = inflight || fetchSignupConfig();
    inflight
      .then((c) => {
        cached = c;
        if (!cancelled) setConfig(c);
      })
      .catch(() => {
        inflight = null;
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, error, loading: !config && !error };
}
